export const ADD_ERROR_MESSAGES = 'ADD_ERROR_MESSAGES';
export const ADD_SUCCESS_MESSAGE = 'ADD_SUCCESS_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
